module.exports = __webpack_public_path__ + "static/img/re_dashboard.83e2964b.png";